import calls from '@/backend/api-calls'


const state = () => ({
  productInventory: [],
  selected: [],
  allSelected: false,
  loading: false,
  pagination: {
    page: 1,
    pages: 1
  },
  filters: {
    project_id: null
  }
})


const getters = {
  ids: state => {
    return state.productInventory.map(d => d.id);
  }
}


const actions = {
  getInventory: ({commit}, parameters) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.inventories.get(parameters)
        .then(resp => {
          commit("setInventory", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  adjustInventory({commit}, data) {
    return new Promise((resolve, reject) => {
      calls.inventories.adjust(data)
        .then(resp => {
          commit("insertUpdatedInventory", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Inventory successfully adjusted'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  transferToProject({commit}, data) {
    return new Promise((resolve, reject) => {
      let transferProps = {
        transfer_from: "inventory",
        transfer_to: "project_inventory"
      }

      calls.inventories.transfer({
        ...transferProps,
        ...data
      }).then(resp => {
        commit("insertUpdatedInventory", resp.data);
        commit("app/setNotification", {
          type: 'success',
          status: true,
          message: 'Inventory successfully transferred'
        }, { root: true });
        resolve(resp);
      }).catch(err => {
        reject(err);
      })
    })
  },
  // transformInventory({commit}, data) {
  //   return new Promise((resolve, reject) => {
  //     calls.inventories.transform(data).then(resp => {
  //       commit("insertUpdatedInventory", resp.data);
  //       commit("app/setNotification", {
  //         type: 'success',
  //         status: true,
  //         message: 'Inventory successfully transformed'
  //       }, { root: true });
  //       resolve(resp);
  //     }).catch(err => {
  //       reject(err);
  //     })
  //   })
  // },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.ids);
    } else {
      commit("deselectAll");
    }
  }
}


const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setInventory(state, data) {
    state.pagination = data.pagination;
    state.productInventory = data.results;
  },
  insertUpdatedInventory(state, data) {
    state.productInventory.forEach((inventory, i) => {
      if (inventory.id == data.id) {
        state.productInventory.splice(i, 1, data);
      }
    })
  },
  selectAll(state, ids) {
    state.allSelected = true;
    ids.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  },
  changePage(state, page) {
    state.pagination.page = page;
  }
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}